import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest } from "../../../api";

import {
    FETCH_TIMESHEET_MANAGER_INBOX_REQUEST,
    fetchManagerInboxSuccess,
    fetchManagerInboxFail,
    fetchManagerInboxRequest,

    FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,
    fetchAdminInboxSuccess,
    fetchAdminInboxFail,
    fetchAdminInboxRequest,

    TIMESHEET_MANAGER_DECISION_REQUEST,
    managerDecisionSuccess,
    managerDecisionFail,

    TIMESHEET_ADMIN_DECISION_REQUEST,
    adminDecisionSuccess,
    adminDecisionFail,

    FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST,
    fetchManagerHistorySuccess,
    fetchManagerHistoryFail,
    fetchManagerHistoryRequest,

    FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST,
    fetchAdminHistorySuccess,
    fetchAdminHistoryFail,
    fetchAdminHistoryRequest,
} from "../actions/timesheetWorkflowActions";

const extractError = (e, fallback) =>
    e?.response?.data?.message || e?.message || fallback;

export function* fetchManagerInboxSaga() {
    const url   = `${API_BASE_URL}/api/timesheets/manager/inbox`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchManagerInboxSuccess(resp.data || []));
    } catch (e) {
        yield put(fetchManagerInboxFail(extractError(e, "Erreur chargement inbox manager")));
    }
}

export function* fetchAdminInboxSaga() {
    const url   = `${API_BASE_URL}/api/timesheets/admin/inbox`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchAdminInboxSuccess(resp.data || []));
    } catch (e) {
        yield put(fetchAdminInboxFail(extractError(e, "Erreur chargement inbox admin")));
    }
}

export function* fetchManagerHistorySaga() {
    const url   = `${API_BASE_URL}/api/timesheets/manager/history`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchManagerHistorySuccess(resp.data || []));
    } catch (e) {
        yield put(fetchManagerHistoryFail(extractError(e, "Erreur chargement historique manager")));
    }
}

export function* fetchAdminHistorySaga() {
    const url   = `${API_BASE_URL}/api/timesheets/admin/history`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchAdminHistorySuccess(resp.data || []));
    } catch (e) {
        yield put(fetchAdminHistoryFail(extractError(e, "Erreur chargement historique admin")));
    }
}

export function* timesheetManagerDecisionSaga(action) {
    const { id, decision, comment } = action.payload;
    const url   = `${API_BASE_URL}/api/timesheets/${id}/manager-decision`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(postRequest, {
            url, token, headers: { uid },
            data: { decision, comment },
        });
        yield put(managerDecisionSuccess(resp.data));
        yield put(fetchManagerInboxRequest());
        yield put(fetchManagerHistoryRequest());
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: decision ? "Timesheet validé" : "Timesheet refusé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = extractError(e, "Erreur lors de la décision manager");
        yield put(managerDecisionFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error", text: msg, timer: 2200, showConfirmButton: false,
        });
    }
}

export function* timesheetAdminDecisionSaga(action) {
    const { id, decision, comment } = action.payload;
    const url   = `${API_BASE_URL}/api/timesheets/${id}/admin-decision`;
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    try {
        const resp = yield call(postRequest, {
            url, token, headers: { uid },
            data: { decision, comment },
        });
        yield put(adminDecisionSuccess(resp.data));
        yield put(fetchAdminInboxRequest());
        yield put(fetchAdminHistoryRequest());
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: decision ? "Timesheet approuvé" : "Timesheet refusé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = extractError(e, "Erreur lors de la décision admin");
        yield put(adminDecisionFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error", text: msg, timer: 2200, showConfirmButton: false,
        });
    }
}

export default function* watchTimesheetWorkflowSagas() {
    yield takeLatest(FETCH_TIMESHEET_MANAGER_INBOX_REQUEST, fetchManagerInboxSaga);
    yield takeLatest(FETCH_TIMESHEET_ADMIN_INBOX_REQUEST, fetchAdminInboxSaga);
    yield takeLatest(FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST, fetchManagerHistorySaga);
    yield takeLatest(FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST, fetchAdminHistorySaga);
    yield takeLatest(TIMESHEET_MANAGER_DECISION_REQUEST, timesheetManagerDecisionSaga);
    yield takeLatest(TIMESHEET_ADMIN_DECISION_REQUEST, timesheetAdminDecisionSaga);
}
